import React, { memo } from 'react';
import Stack from '@mui/material/Stack';
import Status from 'BaseComponents/MotifStatus';
import { FLOW_STAGE } from 'utils/ignoramusEnums';
import { Typography } from '@mui/material';
import { get } from 'lodash';


export const FlowStageCell = memo(({ row }) => {
  const label = get(FLOW_STAGE, `${row.stage}.label`);
  const color = get(FLOW_STAGE, `${row.stage}.statusListViewColor`);

  return (
    <Stack direction='row' alignItems='center' spacing={1}>
      <Status color={color}>
        <Typography variant='body3'>
          {label}
        </Typography>
      </Status>
    </Stack>
  );
});
